var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.basketIs.initial && !_vm.userIs.initial)?_c('address-line',{attrs:{"user":_vm.user,"address":_vm.userAddress,"inline":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }